<template>
  <div>
    <div>
      <p class="subtitle-1 font-weight-bold">Payout History</p>
    </div>
    <v-simple-table dense>
      <template v-slot:no-data>
        No Data
      </template>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Requestor</th>
            <th class="text-left">Date Time</th>
            <th class="text-left">Old Amount</th>
            <th class="text-left">New Amount</th>
            <th class="text-left">Reasons</th>
            <th class="text-left">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in pairing.activity" :key="index">
            <td>{{ item.requestor || '-' }}</td>
            <td>{{ utils.func.formatCustomDate(item.createdAt, 'DD/MM/YYYY hh:mm:ss') }}</td>
            <td>${{ item.oldAmount | thousandSeprator }}</td>
            <td>${{ item.newAmount | thousandSeprator }}</td>
            <td>{{ item.reasons }}</td>
            <td style="width:100px">
              <div class="text-center" v-if="item.status === 'pending'">
                <v-btn class="btn__p100 ma-1" small color="success" @click="updatePairingActivity(item, 'approve')">
                  Approve
                </v-btn>
                <v-btn class="btn__p100 ma-1" small color="error" @click="updatePairingActivity(item, 'reject')">
                  Reject
                </v-btn>
              </div>
              <div v-else>
                <v-chip
                  color="success"
                  x-small
                  text-color="white"
                  v-if="item.status === 'approve'">
                  Approved
                </v-chip>
                <v-chip
                  color="red"
                  x-small
                  text-color="white"
                  v-if="item.status === 'reject'">
                  Rejected
                </v-chip>
                <v-chip
                  color="red"
                  x-small
                  text-color="white"
                  v-if="item.status === 'cancel'">
                  Cancelled
                </v-chip>
                <span class="text-caption" style="font-size: 10px!important" v-if="item.actor">by {{item.actor}}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="90"
      height.number="90"
    ></loading>
  </div>
</template>
<script>
import utils from '@/utils'
import { mapState } from 'vuex';
import Loading from 'vue-loading-overlay';
import UserAPIs from '../../User/userAPIs'
export default {
  name: 'PayoutActivityDataTable',
  components: {
    Loading
  },
  props: ['pairing', 'activityRefresh'],
  data() {
    return {
      utils,
      isLoading: false
    }
  },
  computed: {
    ...mapState({
      savedPayoutActivity: state => state.pairing.savedPayoutActivity
    })
  },
  watch: {
    activityRefresh: {
      handler() {
        this.setActivities()
      },
      deep: true
    }
  },
  methods: {
    updatePairingActivity(item, status) {
      this.$swal({
        title: `Are you sure you want to ${status}?`,
        icon: 'warning',
        confirmButtonText: 'Confirm',
        showCancelButton: true
      }).then(async (result) => {
        if (result.value) {
          this.isLoading = true
          let saveData = Object.assign({}, {
            pairingID: this.pairing.pairingID,
            createdAt: item.createdAt,
            status
          })
          await this.$store.dispatch('pairing/updatePayoutActivity', saveData)
          this.isLoading = false
          if (this.savedPayoutActivity) {
            this.$swal({
              text: `Payout ${status === 'approve' ? 'Approved' : 'Rejected'}.`,
              type: 'success'
            })
            this.$emit('saved')
          } else {
            this.$swal({
              text: 'Error Payout Confirmation!',
              type: 'error'
            })
          }
        }
      })
    },
    async setActivities() {
      // this will set activites state and also set requestor and actor user name from user API
      if (this.pairing.activity && Array.isArray(this.pairing.activity)) {
        this.pairing.activity = Object.assign([], this.pairing.activity)
        for (const [key, value] of Object.entries(this.pairing.activity)) {
          // get requestor name
          let user = await UserAPIs.getUser(value.userID)
          if (user) {
            this.pairing.activity[key].requestor = `${user.firstName} ${user.lastName}`
          }
          // get approve user name
          if (value.actionUserID) {
            let actionUser = await UserAPIs.getUser(value.actionUserID)
            if (actionUser) {
              this.pairing.activity[key].actor = `${actionUser.firstName} ${actionUser.lastName}`
            }
          }
        }
      }
      this.pairing.activity = utils.func.refreshJSON(this.pairing.activity)
    }
  }
}
</script>



// WEBPACK FOOTER //
// PayoutActivityDataTable.vue?1952f26b